function toArrayBuffer( buf ) {
	const ab = new ArrayBuffer( buf.length );
	const view = new Uint8Array( ab );
	for ( let i = 0; i < buf.length; ++i ) {
		view[i] = buf[i];
	}
	return ab;
}

export default async function ( assetName, buffer ) {
	const arrayBuffer = toArrayBuffer( buffer.data );
	const blob = new Blob( [arrayBuffer], { type : 'application/pdf' } );
	const filename = `${assetName}-${( new Date() ).toISOString()}`;

	if ( window.navigator.msSaveOrOpenBlob ) { // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
		window.navigator.msSaveBlob( blob, `${filename}.pdf` );
	}
	else {
		const a = window.document.createElement( 'a' );
		a.href = window.URL.createObjectURL( blob );
		a.download = `${filename}.pdf`;
		document.body.appendChild( a );
		a.click(); // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
		document.body.removeChild( a );
	}
}
